import { useState } from 'react';
import { PortfolioEnterpriseProductGetDetailResult } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { Stack, Tab, Tabs } from '@optimus-web/core';
import { LocalProductAccounting } from './LocalProductAccounting';
import { LocalProductGeneral } from './LocalProductGeneral';
import { LocalProductPricing } from './LocalProductPricing';
import { LocalProductServices } from './LocalProductServices';
import { LocalProductSidePanelTabValues } from './LocalProductSidePanelTabsEnum';

export const LocalProductSidePanelTabs = (data: PortfolioEnterpriseProductGetDetailResult & { propertyId: string }) => {
    const [activeTab, setActiveTab] = useState<LocalProductSidePanelTabValues>(LocalProductSidePanelTabValues.General);

    const content = {
        [LocalProductSidePanelTabValues.General]: (
            <LocalProductGeneral
                productKey={data.details.key}
                {...data.details}
                propertyId={data.propertyId}
                enterpriseProductId={data.enterpriseProductId}
                centralProductId={data.centralProductId}
            />
        ),
        [LocalProductSidePanelTabValues.Pricing]: (
            <LocalProductPricing
                propertyId={data.propertyId}
                enterpriseProductId={data.enterpriseProductId}
                centralProductId={data.centralProductId}
                {...data.pricing}
            />
        ),
        [LocalProductSidePanelTabValues.Services]: (
            <LocalProductServices servicesData={data.services} enterpriseProductId={data.enterpriseProductId} />
        ),
        [LocalProductSidePanelTabValues.Accounting]: (
            <LocalProductAccounting
                propertyId={data.propertyId}
                enterpriseProductId={data.enterpriseProductId}
                centralProductId={data.centralProductId}
                {...data.accounting}
            />
        ),
    };

    return (
        <Stack spacing="400" vertical>
            <Tabs
                inline
                activeTabValue={activeTab}
                onTabClick={(_, value) => setActiveTab(value as LocalProductSidePanelTabValues)}
                showDivider
            >
                <Tab
                    inline
                    id={LocalProductSidePanelTabValues.General}
                    value={LocalProductSidePanelTabValues.General}
                    label={lt('General')}
                />
                <Tab
                    inline
                    id={LocalProductSidePanelTabValues.Pricing}
                    value={LocalProductSidePanelTabValues.Pricing}
                    label={lt('Pricing')}
                />
                <Tab
                    inline
                    id={LocalProductSidePanelTabValues.Services}
                    value={LocalProductSidePanelTabValues.Services}
                    label={lt('GeneralServices')}
                />
                <Tab
                    inline
                    id={LocalProductSidePanelTabValues.Accounting}
                    value={LocalProductSidePanelTabValues.Accounting}
                    label={lt('Accounting')}
                />
            </Tabs>
            {content[activeTab]}
        </Stack>
    );
};
